import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './config/axios'
import AxiosPlugin from 'vue-axios-cors';
import './config/icons'
import './config/msg'
import Maska from 'maska'

Vue.config.productionTip = false

Vue.filter('dinheiro', valor => {
	return valor == null || isNaN(valor) ? 'R$ 0,00' : valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
})

Vue.filter('dinheiroDecimal', valor => {
	return valor == null || isNaN(valor) ? 'R$ 0,00' : valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL', minimumFractionDigits: 4});
})

Vue.use(Maska)
Vue.use(AxiosPlugin)
new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
